const state = () => ({
  inSharePage: false,
  subjectId: 2
});


// getters
const getters = {

};

// actions
const actions = {

};

// mutations
const mutations = {

  updateShareState(state, share) {
    // console.log(gradeInfo)
    state.inSharePage = share
  },
  updateSubjectId(state, subjectId) {
    state.subjectId = subjectId;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};


// WEBPACK FOOTER //
// ./src/store/modules/Share.js